import React, { useState,useEffect } from "react";
import { motion } from "framer-motion";

function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component loads
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <motion.div
      className="mt-20"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
    <div className="max-w-screen-lg mx-auto p-5 mt-20">
      <div className="grid grid-cols-1 md:grid-cols-12 border">
        <div className="bg-cyan-900 md:col-span-4 p-10 text-white">
          <p className="mt-4 text-sm leading-7 font-regular uppercase">Contact</p>
          <h3 className="text-3xl sm:text-4xl leading-normal font-extrabold tracking-tight">
            Get In <span className="text-gray-900">Touch</span>
          </h3>
          <p className="mt-4 leading-7 text-gray-200 text-left">
          Tired of cars blocking the pavement outside your property?
              Pavement parking is not only frustrating but can also be unsafe,
              especially for pedestrians, parents with prams, and people using
              wheelchairs. We’re here to make taking action easy.          </p>
          <div className="flex items-center mt-5">
            
            <span className="text-sm text-left">
            GET OFF THE PAVEMENT LTD
            Company number 16165959
            </span>
          </div>
          <div className="flex items-center mt-5">
          
            <span className="text-sm text-left"> Tel: 07789 119 299
<br/>Email: info@getoffthepavement.co.uk

            </span>
          </div>
          <div className="flex items-center mt-5">
           
            <span className="text-sm text-left">2 Burns House, <br/>
Axminster Crescent<br/> 
London<br/>
DA16 1EY
</span>
          </div>
        </div>
        <form
          className="md:col-span-8 p-10"
          action="https://formsubmit.co/info@getoffthepavement.co.uk"
          method="POST"
          onSubmit={handleFormSubmit}
        >
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                First Name
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                name="first_name"
                placeholder="Jane"
                required
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Last Name
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                name="last_name"
                placeholder="Doe"
                required
              />
            </div>
          </div>
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full px-3">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Email Address
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="email"
                name="email"
                placeholder="your-email@example.com"
                required
              />
            </div>
          </div>
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full px-3">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Your Message
              </label>
              <textarea
                rows="10"
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                name="message"
                placeholder="Your message here..."
                required
              ></textarea>
            </div>
            <div className="flex justify-between w-full px-3">
              
              <button
                className="shadow bg-cyan-900 hover:bg-gray-900 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-6 rounded"
                type="submit"
              >
                Send Message
              </button>
            </div>
          </div>
          {submitted && (
            <p className="text-red-500 text-xs italic">
              Please do not share sensitive information. This form is for general inquiries only.
            </p>
          )}
        </form>
      </div>
    </div></motion.div>
  );
}

export default Contact;
